
import {Typography} from '@mui/material';

const MuiTypography = Typography;
export default MuiTypography;
